/**
 * Created by Gaplo917 on 8/7/2017.
 */
import * as PIXI from "pixi.js"
import SoundManager from "./SoundManager";
const Matter = require("matter-js")
import BaseGame from './BaseGame'

import R from "./config/R"
import TWEEN from "@tweenjs/tween.js"
import * as $ from 'jquery'
import * as Events from "./Events"
import * as SoundUtils from './SoundUtils'

import Scene1 from "./Scene1";
import Scene2 from "./Scene2";
import * as GameScenes from "./scenes/index"

export default class MainGame extends BaseGame {
  constructor() {
    super()
  }

  init() {
    const app = this.app
    app.stage.displayList = new PIXI.DisplayList()

    const engine = this.engine
    const runner = this.runner
    // The application will create a canvas element for you that you
    // can then insert into the DOM.
    document.body.appendChild(app.view)

    this.loadResource({
      onProgress: (percentage) => {
        $('#progress').text(`Loading ${parseInt(percentage)}%`)
      },
      onCompleted: (resources) => {
        Events.hub.publishEvent(Events.LOAD_COMPLETE)

        let scene = new Scene1(resources)

        // for dev
        if(process.env.NODE_ENV === 'development'){

          // scene = new Scene2(resources)
          // scene = new GameScenes.LevelScene1(resources, {passedLevel : 0})
          // scene = new GameScenes.LevelScene2(resources, {passedLevel : 0})
          // scene = new GameScenes.LevelScene3(resources, {passedLevel : 0})
          // scene = new GameScenes.EndGameScene(resources, {passedLevel : 0})
          // scene = new Scene2(resources)
        }


        // Add the bunny to the scene we are building.
        app.stage.addChild(scene)

        // Listen for frame updates
        app.ticker.add((time) => {
          try {
            TWEEN.update()
          } catch (e){
            console.warn("tween throw error, just ignore it", e)
          }
        })

        this.currentScene = scene
        this.resources = resources
      }
    })

    Events.hub.getEventStream(Events.NEXT_SCENE).subscribe(event => {
      console.log("received next scene event...", event)
      app.stage.removeChild(this.currentScene)

      if(event.scene !== R.scenes.END_GAME) {
        SoundManager.instance.stopEffectSounds()
      }

      const scene = this.createSceneFromEvent(event)

      app.stage.addChild(scene)

      this.currentScene = scene
    })
  }

  createSceneFromEvent(event){
    switch(event.scene) {
      case R.scenes.START:
        return new Scene1(this.resources)
      case R.scenes.SELECTION:
        return new Scene2(this.resources)
      case R.scenes.LEVEL_1:
        return new GameScenes.LevelScene1(this.resources, event.data)
      case R.scenes.LEVEL_2:
        return new GameScenes.LevelScene2(this.resources, event.data)
      case R.scenes.LEVEL_3:
        return new GameScenes.LevelScene3(this.resources, event.data)
      case R.scenes.END_GAME:
        return new GameScenes.EndGameScene(this.resources, event.data)
      default:
        throw Error("unknown scene")
    }
  }
}
MainGame.instance = new MainGame()



// WEBPACK FOOTER //
// ./src/game/MainGame.js